import React from 'react'
import Layout from '../modules/Layout'

// TODO: Weiterleitung "technisch" Prüfen.

const EmailAbbinderPage = ({ content, locale }) => {
  if (typeof window !== 'undefined') {
    let target = content.URL.cached_url
    if (target !== '') {
      window.location.href = target
    }
  }

  return (
    <div>
      <Layout locale={locale} />
    </div>
  )
}

export default EmailAbbinderPage
